<template>
    <div class="main">
        <a-spin class="load" v-show="loading" />
        <div class="left">
            <div class="top">
                <div class="textArea">
                    <a-textarea v-model="replayValue" placeholder="分享工作和学习中有趣、好玩的事……" :auto-size="{ minRows: 4, maxRows: 4 }" />
                    <a-button @click="publish" class="fb" type="primary">发布</a-button>
                </div>
            </div>
            <div class="bot">
                <a-list item-layout="horizontal" :data-source="listData1">
                    <a-list-item class="li" slot="renderItem" slot-scope="item, index">
                        <div class="mes">
                            <div class="mesLeft">
                                <img v-if="item.userPhotoPath&&item.userPhotoPath!=null" class="userImg" :src="$userINfoBasePath+'/'+item.userPhotoPath" alt="" />
                                <img class="userImg" v-else src="../../assets/imgs/teacher.png" alt="" />
                            </div>
                            <div class="mesRight">
                                <div class="name">{{item.userName}}</div>
                                <div class="content">{{item.content}}</div>
                                <div class="dianzan">
                                    <template>
                                        <span key="message" class="goodMess">
                                            <a-icon type="message"
                                            @click="loadMore(item)"
                                            />
                                            {{item.replyCount || 0}}
                                        </span>
                                        <span key="like-o" class="goodImg">
                                            <a-icon type="like"
                                                    :theme="item.isPraise === 1 ? 'filled' : 'outlined'"
                                                    @click="praise(item,1)" />
                                            {{item.praiseNumber || 0}}
                                        </span>
                                    </template>
                                    <span class="dateTime">{{format.format(item.createDate)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="selfReplay" v-show="index!==targetIndex">
                            <img v-if="myPhoto&&myPhoto!=null"  class="userPhoto" :src="$userINfoBasePath+'/'+myPhoto" alt="" />
                            <img v-else class="userPhoto"  src="../../assets/imgs/teacher.png" alt="" />
                            <span class="speak" @click="saySelf(index)">说下自己的看法吧</span>
                        </div>
                        <div class="selfReplay">
                            <div class="fb_box" v-show="index===targetIndex">
                                <a-textarea v-model="myReplayValue" :auto-size="{ minRows: 4, maxRows: 4 }" />
                                <div class="fb_d">
                                    <a-button class="fb" type="primary" @click="replyPublish(item,1)">发布</a-button>
                                </div>
                            </div>
                            <div class="commentList" style="display:none">
                                <div class="mes1" v-for="(i,index) in item.replys" :key="index">
                                    <div class="mesLeft">
                                        <img v-if="i.userPhotoPath" class="userImg" :src="$userINfoBasePath+'/'+i.userPhotoPath" alt="" />
                                        <img class="userImg" v-else src="../../assets/image/21.png" alt="" />
                                    </div>
                                    <div class="mesRight">
                                        <div class="name">{{i.userName}}<span v-if="i.reuserName">@</span> {{i.reuserName}}</div>
                                        <div class="content">{{i.content}}</div>
                                        <div class="dianzan">
                                            <template>
                                                <span key="message" class="goodMess">
                                                    <a-icon type="message"
                                                        @click="praiseMess(i)"
                                                    />
                                                </span>
                                                <span key="like-o" class="goodImg">
                                                    <a-icon type="like"
                                                            :theme="i.isPraise === 1 ? 'filled' : 'outlined'"
                                                            @click="praise(i,2)" />
                                                    {{i.praiseNumber || 0}}
                                                </span>
                                            </template>
                                            <span class="dateTime">{{format.format(i.createDate)}}</span>
                                        </div>
                                        <!-- <div class="all_answer" @click="loadMore(item)">加载更多</div> -->
                                        <div class="fb_box" v-show="i===targetIndex2">
                                            <a-textarea v-model="myReplayValue" :auto-size="{ minRows: 4, maxRows: 4 }" />
                                            <div class="fb_d">
                                                <a-button class="fb" type="primary" @click="replyPublish(item,2)">发布</a-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a-list-item>
                </a-list>
                <div style="text-align:center;margin-top:20px;height:50px;">
                    <a-config-provider>
                    <a-pagination
                        show-quick-jumper
                        :default-current="1"
                        :page-size="pageSize"
                        @change="handleListChange"
                        show-less-items
                        :total=total />
                    </a-config-provider>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <div class="user">
                    <img v-if="myPhoto&&myPhoto!=null" class="userImg" :src="$userINfoBasePath+'/'+myPhoto" alt="" />
                    <img v-else class="userImg"  src="../../assets/imgs/teacher.png" alt="" />
                    <span class="userName">{{userName}}</span>
                </div>
                <div class="userDetail">
                    <div class="left">
                        <div class="num">{{userMess.pushCount || 0}}</div>
                        <div class="text">我发布的</div>
                    </div>
                    <div class="right">
                        <div class="num">{{userMess.praiseNum || 0}}</div>
                        <div class="text">获赞</div>
                    </div>
                </div>
            </div>
            <div class="bot">
                <div class="myReplay">
                    <img class="messImg" src="../../assets/teacherRoad/26.png" alt="" />
                    <span class="text">我的评论</span>
                </div>
                <ul class="replyList">
                    <li v-for="(item,index) in commentListRight" :key="index">
                        <div class="name_rp">
                            <span class="na">{{item.recuserName}}</span>
                            <span class="re">回复{{item.userName}}</span>
                        </div>
                        <div class="content">{{item.commentContent}}</div>
                        <div class="mainCont">
                            <div class="name_cont">{{item.content}}</div>
                            <!-- <div class="name_cont">
                                {{item.content}}
                            </div> -->
                        </div>
                    </li>
                </ul>
                <div class="lookAll" @click="lookAllFun">查看全部</div>
            </div>
            <div class="myRelease">
                    <div class="myReplay">
                        <img class="messImg" src="../../assets/teacherRoad/27.png" alt="" />
                        <span class="text">我发布的</span>
                    </div>
                    <ul class="comList">
                        <li class="commentLi" v-for="(item,index) in publishListRight" :key="index">
                            {{item.content}}
                        </li>
                    </ul>
                    <div class="lookAll" @click="lookAllPublish">查看全部</div>
                </div>
        </div>
        <!-- 查看全部交流广场回答 -->
        <a-modal v-model="lookMoreModal"
                width="1100px"
                title="全部回答"
                forceRender
                destroyOnClose
                footer="">
        <div class="mesMore">
            <a-list item-layout="vertical" size="large" :data-source="moreMess">
            <a-list-item slot="renderItem"
                        key="item.title"
                        slot-scope="item, index">
                <a-list-item-meta>
                <span slot="title" :href="$userINfoBasePath+item.userPhotoPath">
                    <img v-if="item.userPhotoPath&&item.userPhotoPath!=null" class="avatar-img" :src="$userINfoBasePath+'/'+item.userPhotoPath" />
                    <img v-else class="avatar-img" src="../../assets/imgs/teacher.png" />
                {{ item.userName }}
                    <span v-if="item.reuserName">@</span>
                    <!-- <img v-if="item.reuserPhotoPath&&item.reuserPhotoPath!=null" class="avatar-img" :src="$userINfoBasePath+'/'+item.reuserPhotoPath" /> -->
                    <!-- <img v-else class="avatar-img" src="../../assets/imgs/teacher.png" /> -->
                    {{item.reuserName}}
                </span>

                </a-list-item-meta>
                <p class="content">{{item.content}}</p>
                <div class="time">
                <span class="dianzanMore">
                    <template>
                    <span key="message">
                        <a-icon type="message" @click="Infobox(item,1)" />
                        {{ item.replyCount || 0 }}
                    </span>
                    <span class="goodMess">
                        <a-icon type="like" :theme="item.isPraise === 1 ? 'filled' : 'outlined'" @click="praise(item,2)" />
                        {{ item.praiseNumber || 0 }}
                    </span>
                    </template>
                </span>
                <span class="dzTime">{{format.format(item.createDate)}}</span>
                </div>
                <div class="replyMes" v-if="item.subReplyList&&item.subReplyList.length>0">
                    <div class="replyMesDetail"
                        v-for="(t,index) in item.subReplyList"
                        :key="index">
                        <div>
                            <a-avatar class="replayUserImg" slot="avatar" :src="t.userPhotoPath&&t.userPhotoPath!=null?$userINfoBasePath+'/'+t.userPhotoPath:'../../assets/imgs/teacher.png'" />
                            <span class="replayName">{{t.userName}}</span>
                            <img class="img_img" src="../../assets/imgs/teacherRoadImg/@.png" alt="" />
                            <span class="replayUserName">{{t.reuserName}}</span>
                        </div>
                        <p class="replyContent">{{t.content}}</p>
                        <!-- <div class="replyTime">
                            <span class="dianzan">
                            <template>
                                <span key="message"
                                    class="goodMess">
                                    <a-icon type="message" @click="Infobox(t,2)" />
                                </span>
                                <span class="likeo">
                                    <a-icon type="like"
                                            :theme="t.isPraise === 1 ? 'filled' : 'outlined'"
                                            @click="praise(t,2)" />
                                    {{t.praiseNumber || 0}}
                                </span>
                            </template>
                            </span>
                            <span class="time">{{format.format(t.createDate)}}</span>
                        </div> -->
                    </div>
                </div>
            </a-list-item>
            </a-list>
        </div>
        </a-modal>
        <!--回答弹窗-->
        <a-modal v-model="answerModal"
                style="z-index:999999;"
                width="1100px"
                destroyOnClose
                title=""
                footer="">
        <div class="answerMes">
            <div><span class="answerText">回答</span><span class="answerName">{{replyMess.userName || replyMess.reuserName}}</span></div>
            <div class="answerTitle">{{replyMess.content|| replyMess.replyContent}}</div>
            <div class="answerBgc">
            <a-textarea class="area" v-model="myReplayValue" :auto-size="{ minRows: 6, maxRows: 10 }" />
            </div>
        </div>
        <div class="askHelp">
            <a-button class="ask" @click="replyPublish(replyMess,2)">发布</a-button>
        </div>
        </a-modal>
    </div>
</template>

<script>
import format from '@/utils/format.js'
export default {
    name: 'chatRoom',
    data(){
        return {
            format,
            loading:false,
            resBasePath: this.$resBasePath,
            replayValue: '',
            myReplayValue: '', //我回复的内容
            pageNum: 1,
            pageSize:5,
            listData1: [],
            total:0,
            type: 1,
            myPhoto: this.$getUserInfo().photo,
            userName: this.$getUserInfo().name,
            targetIndex: -1,
            targetIndex2: -1, //第二层的展示
            replyList: [],
            commentList: [],
            commentListRight: [],//我的评论
            publishListRight: [],// 我发布的
            userMess:{},
            newReplyList: [],
            lookMoreModal: false,
            moreMess: [],// 更多回答
            answerModal: false,// 评论弹框
            replyMess: {},
            localItem: '' //缓存弹窗刷新参数
        }
    },
    mounted(){
        this.getDataList()
        this.getTeacherCommentList()
        this.getpublishList()
        this.getMyCommentPage()
    },
    methods:{
        //评论回复列表
        getDataList () {
            const param = {
                userId: this.$getUserInfo().id,
                type: this.type,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/exchangeSpaceList',
                body: param
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res => {
                if (res && res.success && res.resultCode === 0) {
                    this.listData1 = res.resultData.list
                    this.total = res.resultData.total
                }
            })
        },
        //老师评论信息
        getTeacherCommentList(){
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/getPushCountByUserId',
                body: {
                    userId: this.$getUserInfo().id
                }
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res =>{
                if(res && res.success && res.resultCode === 0){
                    this.userMess = res.resultData
                }
            })
        },
        //我的评论
        getMyCommentPage(){
            const param = {
                type: 1,
                userId: this.$getUserInfo().id,
                pageSize: 2,
                pageNum: 1
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/getMyCommentPage',
                body: param
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.commentListRight = res.resultData.list
                }
            })
        },
        //我的发布ebook/teacher/exchangeSpace/exchangeSpaceList
        getpublishList(){
            const param = {
                type: 2,
                userId: this.$getUserInfo().id,
                pageSize: 3,
                pageNum: 1
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/exchangeSpaceList',
                body: param
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.publishListRight = res.resultData.list
                }
            })
        },
        // 发布留言
        publish(){
            const param = {
                userId: this.$getUserInfo().id,
                content: this.replayValue
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/pushExchangeSpace',
                body: param
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res => {
                if(res && res.success && res.resultCode === 0){
                    this.getDataList()
                    this.getTeacherCommentList()
                    this.getpublishList()
                    this.replayValue = ''
                }
            })
        },
        loadMore (item) {
            this.lookMoreModal = true
            const param = {
                id: item.id,
                userId: item.userId,
                pageSize: 10,
                pageNum: 1
            }
            this.$fetch({
                url: this.$baseUrl + 'ebook/teacher/exchangeSpace/getExchangeSpaceReplyPage',
                body:param
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res => {
                if(res && res.success && res.resultCode === 0){
                    if(res.resultData!= null){
                        this.moreMess = res.resultData.list
                    }
                }
            })
        },
        //点赞功能
        praise (item, type) {
            const url = item.isPraise === 1 ? 'ebook/teacher/exchangeSpace/exchangeSpaceCancelClickPraise' : 'ebook/teacher/exchangeSpace/exchangeSpaceClickPraise'
            const param = {
                id: item.id,
                type: type,
                userId: this.$getUserInfo().id
            }
            this.$fetch({
                url: this.$baseUrl + url,
                body: param
            }).loading(
                () => (this.loading = true),
                () => (this.loading = false)
            ).done(res => {
                if (res && res.success && res.resultCode === 0) {
                if (type === 1) {
                    if (item.isPraise === 1) {
                        item.isPraise = 0
                        item.praiseNumber = parseInt(item.praiseNumber) - 1
                    } else {
                        item.isPraise = 1
                        item.praiseNumber = parseInt(item.praiseNumber) + 1
                    }
                    this.getTeacherCommentList()
                } else {
                    if (item.isPraise === 1) {
                        item.isPraise = 0
                        item.praiseNumber = parseInt(item.praiseNumber) - 1
                    } else {
                        item.isPraise = 1
                        item.praiseNumber = parseInt(item.praiseNumber) + 1
                    }
                    this.getTeacherCommentList()
                }
                }
            })
        },
        //评论回复
        replyPublish(item,type){
            let content = '', parentId = '', id = ''
            if (type == 1) {
                content = this.myReplayValue
                parentId = 0
                id = item.id
            } else {
                content = this.myReplayValue
                parentId = item.id
                id = item.rootId
            }
            const param = {
                type: type,
                userId: this.$getUserInfo().id,
                reUserId: item.userId, // 被回复ID
                rootId: id, // 顶层互动提问id
                parentId: parentId, // 被评论回复id type为1 时传 0
                content: content // 评论内容
            }
            this.$fetch({
                    url: this.$baseUrl + 'ebook/teacher/exchangeSpace/commentReply',
                    body: param
                }).loading(
                    () => (this.loading = true),
                    () => (this.loading = false)
                ).done(res => {
                    if (res && res.success && res.resultCode === 0) {
                        this.$message.success('发布成功')
                        this.lookMoreModal = false
                        this.answerModal = false
                        this.getDataList()
                        this.targetIndex = -1
                    }
                })
        },
        praiseMess(index){
            this.myReplayValue = ''
            this.targetIndex2 = index
        },
        saySelf(index){
            this.myReplayValue = ''
            this.targetIndex = index
        },
        lookAllFun(){
            this.$router.push({name: 'myComment'})
        },
        lookAllPublish(){
            this.$router.push({name: 'myPublish'})
        },
        handleListChange (current, pageSize) {
            this.pageNum = current
            this.pageSize = pageSize
            this.getDataList()
        },
        // 点击信息评论弹框
        Infobox (item, type) {
            this.replyMess = item
            this.myReplayValue = ''
            this.answerModal = true
        },
    }
}
</script>

<style scoped lang="less">
    ul,li{
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .main{
        //width: 1240px;
        height: 800px;
        height: 100%;
        // background: #f6f6f6;
        display: flex;
        margin: 0 auto;
        margin-top: 30px;
        position: relative;
        .load{
            position: absolute;
            top: 40%;
            left: 35%;
            transform: translate(50%, 50%);
            z-index: 99;
        }
        .left{
            //width: 900px;
          flex: 1;
            .top{
                height: 200px;
                background: #fff;
                position: relative;
                border-radius: 8px;
                .textArea{
                    //width: 800px;
                    margin: 0 20px;
                    padding-top: 30px;
                    // background: #F6F6F6;
                    /deep/.ant-input{
                        background-color: #F6F6F6;
                    }
                }
                .fb{
                    position: absolute;
                    right: 50px;
                    bottom: 30px;
                    width: 80px;
                    height: 24px;
                    line-height: 24px;
                    border-radius: 2px;
                }
            }
            .bot{
                //width: 900px;
                min-height: 500px;
                background: #fff;
                margin-top: 30px;
                border-radius: 8px;
                // display: flex;
                ul{
                    width: 100%;
                    .li{
                        min-height: 220px;
                        width: 100%;
                        // border-bottom: 2px dotted #E6DDD0;
                        border-bottom: 1px solid #E6DDD0;
                        display: block;
                        .mes{
                            //width: 800px;
                            margin: 0 20px;
                            border-bottom: 2px dotted #E6DDD0;
                            display: flex;
                            .mesLeft{
                                width: 50px;
                                height: 100%;
                                .userImg{
                                    margin-top: 30px;
                                    width: 36px;
                                    height: 36px;
                                    border-radius: 50%;
                                }
                            }
                            .mesRight{
                                flex: 1;
                                height: 100%;
                                padding: 30px 0px 0px 15px;
                                .name{
                                    font-size: 16px;
                                    font-family: PingFangSC-Semibold, PingFang SC;
                                    font-weight: 600;
                                    color: #000000;
                                    line-height: 24px;
                                }
                                .content{
                                    font-size: 18px;
                                    width: 100%;
                                    font-family: STSongti-SC-Regular, STSongti-SC;
                                    font-weight: 400;
                                    color: #040506;
                                    margin-top: 6px;
                                }
                                .dianzan{
                                    margin: 10px 0px;
                                    .goodMess{
                                        cursor: pointer;
                                    }
                                    .goodImg{
                                        margin-left: 30px;
                                    }
                                    .dateTime{
                                        float: right;
                                    }
                                }
                            }
                        }
                        .selfReplay{
                            margin-left: 100px;
                            margin-top: 20px;
                            margin-bottom: 30px;
                            margin-right: 50px;
                            position: relative;
                            .userPhoto{
                                width: 32px;
                                height: 32px;
                                margin-top: -5px;
                                border-radius: 50%;
                            }
                            .speak{
                                cursor: pointer;
                                display: inline-block;
                                width: 710px;
                                height: 32px;
                                line-height: 32px;
                                background: #F6F6F6;
                                border-radius: 4px;
                                margin-left: 7px;
                                margin-top: 5px;
                                font-size: 14px;
                                font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                                font-weight: 400;
                                color: #7F7F7F;
                                text-indent: 25px;
                            }
                            .fb_box{
                                .fb_d{
                                    height: 35px;
                                    margin-top: 10px;
                                    text-align: right;
                                    .fb{
                                        width: 80px;
                                        height: 24px;
                                        line-height: 24px;
                                        border-radius: 2px;
                                    }
                                }
                            }
                            .commentList{
                                width: 750px;
                                .mes1{
                                    width: 800px;
                                    margin: 0 auto;
                                    // border-bottom: 2px dotted #E6DDD0;
                                    display: flex;
                                    .mesLeft{
                                        width: 50px;
                                        height: 100%;
                                        .userImg{
                                            width: 32px;
                                            height: 32px;
                                            border-radius: 50%;
                                        }
                                    }
                                    .mesRight{
                                        width: 700px;
                                        height: 100%;
                                        word-break: break-all;
                                        // padding: 0px 0px 0px 15px;
                                        .name{
                                            font-size: 16px;
                                            font-family: PingFangSC-Semibold, PingFang SC;
                                            font-weight: 600;
                                            color: #000000;
                                            line-height: 24px;
                                        }
                                        .content{
                                            font-size: 18px;
                                            font-family: STSongti-SC-Regular, STSongti-SC;
                                            font-weight: 400;
                                            color: #040506;
                                            margin-top: 6px;
                                        }
                                        .dianzan{
                                            margin: 10px 0px;
                                            .goodMess{

                                            }
                                            .goodImg{
                                                margin-left: 30px;
                                            }
                                            .dateTime{
                                                float: right;
                                            }
                                        }
                                        .comment_sl{
                                            background: #f6f6f6;
                                            width: 700px;
                                            display: block;
                                            padding: 0px 20px 20px 20px;
                                            .mes_two{
                                                width: 660px;
                                                padding-top: 20px;
                                                border-bottom: 2px dotted #E6DDD0;
                                                display: flex;
                                                .mes_twoLeft{
                                                    width: 50px;
                                                    height: 100%;
                                                    .userImg{
                                                        width: 32px;
                                                        height: 32px;
                                                    }
                                                }
                                                .mes_twoRight{
                                                    width: 640px;
                                                    height: 100%;
                                                    .name{
                                                        font-size: 16px;
                                                        font-family: PingFangSC-Semibold, PingFang SC;
                                                        font-weight: 600;
                                                        color: #000000;
                                                        line-height: 24px;
                                                    }
                                                    .img_s{
                                                        width: 22px;
                                                        height: 22px;
                                                        margin: -4px 5px 0px 5px;
                                                    }
                                                    .someBody{
                                                        font-size: 16px;
                                                        font-family: PingFangSC-Regular, PingFang SC;
                                                        font-weight: 400;
                                                        color: #BDBDBD;
                                                        line-height: 24px
                                                    }
                                                    .content{
                                                        font-size: 18px;
                                                        font-family: STSongti-SC-Regular, STSongti-SC;
                                                        font-weight: 400;
                                                        color: #040506;
                                                        margin-top: 6px;

                                                    }
                                                    .dianzan{
                                                        margin: 10px 0px;
                                                        .goodMess{

                                                        }
                                                        .goodImg{
                                                            margin-left: 30px;
                                                        }
                                                        .dateTime{
                                                            float: right;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .right{
            width: 310px;
            height: 200px;
            background: #fff;
            margin-left: 30px;
            .top{
                height: 200px;
                background: #fff;
                border-radius: 8px;
                .user{
                    width: 150px;
                    margin: 0 auto;
                    padding-top: 20px;
                    // padding: 30px 90px 0px 30px;
                    .userImg{
                        width: 44px;
                        height: 44px;
                        text-align: center;
                        border-radius: 50%;
                        margin-top: -8px;
                    }
                    .userName{
                        display: inline-block;
                        width: 80px;
                        height: 40px;
                        font-size: 20px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #000000;
                        line-height: 40px;
                        margin-left: 20px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowarp;
                    }
                }
                .userDetail{
                    display: flex;
                    margin-top: 30px;
                    .left,.right{
                        cursor: pointer;
                        width: 50%;
                        height: 60px;
                        text-align: center;
                        .num{
                            font-size: 24px;
                            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                            font-weight: bold;
                            font-weight: 600;
                            color: #A3AF90;
                            line-height: 30px;
                        }
                        .text{
                            font-size: 12px;
                            font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                            font-weight: bold;
                            font-weight: 400;
                            color: #000000;
                            line-height: 20px;
                            margin-top: 10px;
                        }
                    }
                    .left{
                        border-right: 1px solid #E6DDD0;
                    }
                    .right{
                        margin-left: 0px;
                    }
                }
            }
            .bot{
                min-height: 280px;
                background: #fff;
                margin-top: 30px;
                padding: 30px;
                border-radius: 8px;
                .myReplay{
                    height: 30px;
                    line-height: 30px;
                    .messImg{
                        width: 16px;
                        height: 14px;
                        margin-top: -4px;
                    }
                    .text{
                        margin-left: 10px;
                        font-size: 16px;
                        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                        font-weight: 400;
                        color: #999999;
                        line-height: 20px;
                    }
                }
                .replyList{
                    li{
                        margin-top: 5px;
                        height: 180px;
                        border-bottom: 1px solid #E6DDD0;
                        .name_rp{
                            margin-top: 5px;
                            height: 20px;
                            line-height: 20px;
                            .na{
                                font-size: 12px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #000000;
                                line-height: 20px;
                            }
                            .re{
                                margin-left: 10px;
                                font-size: 12px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #BDBDBD;
                                line-height: 20px;
                            }
                        }
                        .content{
                            font-size: 14px;
                            font-family: STSongti-SC-Regular, STSongti-SC;
                            font-weight: 400;
                            color: #040506;
                            line-height: 32px;
                            width: 250px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }
                        .mainCont{
                            width: 250px;
                            background: #f6f6f6;
                            border-radius: 4px;
                            min-height: 100px;
                            padding: 10px 20px;
                            .name{
                                font-size: 12px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #000000;
                                height: 25px;
                                line-height: 25px;
                            }
                            .name_cont{
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                }
                .lookAll{
                    cursor: pointer;
                    margin-top: 10px;
                    text-align: center;
                    width: 100%;
                    height: 40px;
                    font-size: 14px;
                    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                    font-weight: 500;
                    color: @primary-color;
                    line-height: 40px;
                }
            }
            .myRelease{
                width: 100%;
                height: 420px;
                background: #fff;
                border-radius: 8px;
                margin-top: 15px;
                padding: 30px;
                .myReplay{
                    height: 30px;
                    line-height: 30px;
                    .messImg{
                        width: 16px;
                        height: 14px;
                        margin-top: -4px;
                    }
                    .text{
                        margin-left: 10px;
                        font-size: 16px;
                        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
                        font-weight: 400;
                        color: #999999;
                        line-height: 20px;
                    }
                }
                .comList{
                    height: 280px;
                    border-bottom: 1px solid #E6DDD0;
                    .commentLi{
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        font-size: 14px;
                        font-family: STSongti-SC-Regular, STSongti-SC;
                        font-weight: 400;
                        color: #040506;
                        margin-top: 30px;
                        &:first-child{
                            margin-top: 10px;
                        }
                    }
                }
                .lookAll{
                    cursor: pointer;
                    margin-top: 10px;
                    text-align: center;
                    width: 100%;
                    height: 40px;
                    font-size: 14px;
                    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
                    font-weight: 500;
                    color: @primary-color;
                    line-height: 40px;
                }
            }
        }
    }
    .all_answer {
        width: 20%;
        margin-top: 1.5rem;
        font-size: 18px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #a3af90;
        cursor: pointer;
        // padding-left: 46px;
        .right {
            width: 16px;
            height: 16px;
            margin-top: -5px;
        }
    }
    //lookmore
    .mesMore {
        min-height: 160px;
        padding: 20px;
        background: #fff;
        overflow-y: auto;
    }
    .dianzanMore {
        // float: right;
        width: 150px;
        text-align: right;
        .goodImg {
            width: 20px;
            height: 20px;
            margin-top: -8px;
            cursor: pointer;
        }
        .goodMess{
            margin-left: 20px;
        }
    }
    .dzTime{
        float: right;
    }
    .askHelp{
        height: 40px;
        line-height: 40px;
        text-align: right;
        .area{
            margin-top: 5px;
        }
        .ask{
            margin-top: 15px;
            width: 80px;
            height: 24px;
            line-height: 24px;
            border-radius: 2px;
            background: @primary-color;
            color:#fff;
        }
    }
    .replyMes{
        padding: 20px;
        margin-top: 10px;
        padding-left: 40px;
        background: #f6f6f6;
        .replyMesDetail{
            padding-bottom: 10px;
            border-bottom: 2px dotted #E6DDD0;
            .replayName{
                margin-left: 10px;
            }
            .img_img{
                width: 20px;
                height: 20px;
                margin: 0px 10px;
            }
            .replyContent{
                padding: 0;
                margin: 0;
                line-height: 30px;
            }
            .time{
                float: right;
            }
            .likeo{
                margin-left: 20px;
            }
        }
    }
    .answerMes{
        .answerText{
            font-size: 14px;
        }
        .answerName{
            font-size: 16px;
            color:#999;
            margin-left:10px;
        }
        .answerTitle{
            text-indent: 35px;
        }
        .answerBgc{
            margin-top: 5px;
        }
    }
    .avatar-img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
</style>
